import { render } from "./OverlayFrame.vue?vue&type=template&id=715a29e8"
import script from "./OverlayFrame.vue?vue&type=script&lang=js"
export * from "./OverlayFrame.vue?vue&type=script&lang=js"

import exportComponent from "/Users/matthew/Documents/Vault/code/sal/ritual/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__